<template>

</template>
<script>
export default {
    data() {
        return {

        }
    },
    created() {
        let url=this.getAuthUrl("wx6eaa0bfca33dd154",window.location.href);
        let code=this.getUrlKey("code");
        if(code){
            this.getWxGzhOpenId(code);
        }
        else{
            window.location.href = url;
            return;
        }
    },
    methods:{
        getWxGzhOpenId(code){
            this.$post("wechat/getWxGzhOpenId",{code:code}).then(res=>{
                if(res.sucess){
                    console.log(res);
                }
            });
        },
        getAuthUrl(appId, currentPageUrl){
            const authUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri="+ encodeURIComponent(currentPageUrl) +"&response_type=code&scope=snsapi_base&state=TOKEN&connect_redirect=1#wechat_redirect"
            return authUrl;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/page/staffband/staffbandwxopenid.vue